










































import { Component, Vue, Prop } from "vue-property-decorator";
import { GetCurrentUserData } from "@/request/account";
import Copy from "@/components/copy.vue";
import Header from "../../components/common-header.vue";
import LeftNav from "../../components/left-nav.vue";
import QAndA from "./qAndA.vue";
@Component({
  components: {
    Header,
    Copy,
    LeftNav,
    QAndA
  }
})
export default class AccountManage extends Vue {
  private user: any = {};
  private cState: any = "文档下载";
  private gongzuozhanUrl: any =
    "https://zydata.oss-cn-shanghai.aliyuncs.com/ds/docs/%E5%B2%90%E9%BB%84%E6%95%B0%E6%8D%AEAI%E5%B7%A5%E4%BD%9C%E7%AB%99%E4%BA%A7%E5%93%81%E4%BD%BF%E7%94%A8%E8%AF%B4%E6%98%8E%E6%96%87%E6%A1%A3%EF%BC%88V1.0%EF%BC%89.pdf";
  private shenqing: any =
    "https://zydata.oss-cn-shanghai.aliyuncs.com/ds/docs/%E6%9C%BA%E6%9E%84%E7%94%A8%E6%88%B7%E5%85%8D%E8%B4%B9%E4%BD%BF%E7%94%A8%E7%94%B3%E8%AF%B7%E8%A1%A8.pdf";
  /**
   * @description 获取用户信息
   */
  private fetchUserData() {
    GetCurrentUserData(this).then((data: any) => {
      this.user = data;
    });
  }
  private stateChange(state) {
    this.cState = state;
  }
  private downloadGongzuozhan() {
    window.open(this.gongzuozhanUrl);
  }
  private downloadShenqing() {
    window.open(this.shenqing);
  }
  /**
   * @description 初始化
   */
  private mounted() {
    this.fetchUserData();
  }
}
